import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/form/Button";
import Image from "../../components/elements/Image";
import { useSelector } from "react-redux";
import logo from "../../assets/images/logo.png";
import UpdatedModal from "../../common/DesignersModal/Modal";
import { AUTH_TOKEN, REFRESH_TOKEN, userType } from "../../utils/constant";
import { useDispatch } from "react-redux";
import AuthProvider from "../../common/Hooks/AuthProvider";
import { subscriptionCheck } from "../../Services/paymentService";
import { useNavigate } from "react-router-dom";

const BuyPlan = () => {
  const { siteSetting } = useSelector((state) => state.setting);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminAccessToken = localStorage.getItem("admin_accessToken");
  const adminRefreshToken = localStorage.getItem("admin_refreahToken");

  const companyAccessToken = localStorage.getItem("company_accessToken");
  const companyRefreshToken = localStorage.getItem("company_refreahToken");

  const [isLogoutDissable, setIsLogOutDissable] = useState(false);
  const { user } = useSelector((state) => state.user);
  const userData = useSelector((state) => state.user);
  let { setToken } = AuthProvider();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const viewRatePage = localStorage.getItem("viewRatePage");
  const viewRatePageUrl = localStorage.getItem("viewRatePageUrl");

  const adminRole = userData?.user?.role?.find(
    (item) =>
      item?.code === "COMPANY-ADMINISTRATOR" || item?.code === "COMPANY-MANAGER"
  );
  const superAdminRole = userData?.user?.role?.find(
    (item) => item?.code === "ADMIN"
  );

  const logOut = () => {
    setIsLogOutDissable(true);
    if (
      companyAccessToken &&
      companyRefreshToken &&
      adminAccessToken &&
      adminRefreshToken
    ) {
      localStorage.setItem("auth_token", companyAccessToken);
      localStorage.setItem("refresh_token", companyRefreshToken);
      localStorage.removeItem("company_accessToken");
      localStorage.removeItem("company_refreahToken");
      window.location.pathname = "/dashboard";
    } else if (adminAccessToken && adminRefreshToken) {
      localStorage.setItem("auth_token", adminAccessToken);
      localStorage.setItem("refresh_token", adminRefreshToken);
      localStorage.removeItem("admin_accessToken");
      localStorage.removeItem("admin_refreahToken");
      window.location.pathname = "/admin/dashboard";
    } else if (companyAccessToken && companyRefreshToken) {
      localStorage.setItem("auth_token", companyAccessToken);
      localStorage.setItem("refresh_token", companyRefreshToken);
      localStorage.removeItem("company_accessToken");
      localStorage.removeItem("company_refreahToken");
      window.location.pathname = "/admin/dashboard";
    } else {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      setToken(null);
      user.role[0].code === userType.admin
        ? (window.location.pathname = "/admin")
        : (window.location.pathname = "/");
      dispatch({ type: "LOGOUT" });
      setIsModalOpen(false);
    }
    setIsLogOutDissable(false);
  };

  const handleSubscriptionChecking = async () => {
    try {
      const res = await subscriptionCheck({});
      if (res?.status === 200) {
        if (res?.data && res?.data?.trans_details) {
          if (
            res?.data?.trans_details?.status === 1 ||
            res?.data?.trans_details?.status === 2
          ) {
            if (viewRatePage === "YES") {
              return navigate(viewRatePageUrl);
            } else {
              return navigate("/dashboard");
            }
          } else {
            navigate("/buy-plan");
          }
        } else {
          navigate("/buy-plan");
        }
      } else {
        navigate("/buy-plan");
      }
    } catch (err) {
      navigate("/buy-plan");
    }
  };

  useEffect(() => {
    if (
      (!adminAccessToken || !adminRefreshToken) &&
      (adminRole?.code === "COMPANY-ADMINISTRATOR" ||
        adminRole?.code === "COMPANY-MANAGER")
    ) {
      handleSubscriptionChecking();
    } else if (superAdminRole?.code === "ADMIN") {
      navigate("/dashboard");
    } else {
      if (viewRatePage === "YES") {
        return navigate(viewRatePageUrl);
      } else {
        return navigate("/dashboard");
      }
    }
  }, [
    adminRole,
    adminAccessToken,
    adminRefreshToken,
    superAdminRole,
    viewRatePageUrl,
    viewRatePage,
  ]);

  return (
    <>
      <section className="relative flex items-center justify-center w-full min-h-screen bg-gradient-to-r from-slate-50 via-slate-100 to-slate-200 py-20">
        <div className="w-full max-w-7xl mx-auto px-6">
          <div
            onClick={() => window.history.pushState({}, "", "/")}
            className="block text-center mb-8"
          >
            <div className="h-20 w-full flex justify-center items-center mb-5">
              <div className="w-56 overflow-hidden">
                <Image
                  src={
                    siteSetting?.footerLogo?.url
                      ? siteSetting?.footerLogo?.url
                      : logo
                  }
                  className="mx-auto w-full h-auto"
                  alt="Site Logo"
                />
              </div>
            </div>
          </div>

          <div className="text-center mb-6 space-y-3">
            <h1 className="text-4xl font-extrabold text-teal-500">
              You’re almost ready to start planning!
            </h1>
            <h2 className="text-3xl font-bold text-blue-600">
              Welcome to 9BoxNow
            </h2>
          </div>

          <div className="flex flex-wrap justify-center -mx-5">
            <div className="w-full max-w-md px-5 py-2">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-50 px-5 py-2">
                  <div className="text-rose-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
                    <i className="fa-solid fa-info-circle"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-yellow-600 text-center">
                    Your account is currently inactive due to a pending payment.
                    To restore access, please contact the administrator for
                    assistance.
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center pt-6">
            <Button
              buttonClasses="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-lg shadow-md transition-all"
              buttonType=""
              buttonHasLink={false}
              buttonLabel="Logout"
              buttonLabelClasses=""
              buttonFunction={() => setIsModalOpen(true)}
            />
          </div>
        </div>
      </section>
      <UpdatedModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={`Logout Confirmation`}
        size="xl"
      >
        <div className="py-5">
          <p>Are you sure that you want to log out?</p>
          <div className=" button relative flex items-center justify-between mt-6">
            <div className="relative">
              <Button
                buttonLabel={"Cancel"}
                buttonLabelClasses={""}
                buttonClasses={
                  "!bg-slate-100 hover:!bg-slate-300 !text-slate-500"
                }
                buttonHasLink={false}
                buttonFunction={() => setIsModalOpen(false)}
              />
            </div>
            <div className="relative">
              <Button
                buttonLabel={"Logout"}
                buttonClasses={
                  "!bg-red-500 hover:!bg-red-400 text-black !text-white"
                }
                buttonHasLink={false}
                buttonFunction={() => logOut()}
                buttonDisabled={isLogoutDissable}
              />
            </div>
          </div>
        </div>
      </UpdatedModal>
    </>
  );
};

export default BuyPlan;
